import { EAssetAcquiredStatuses, EAssetAcquiredStatusesLabels } from '@enums/asset';

export const acquiresAssetStatuses = [
	{
		label: EAssetAcquiredStatusesLabels.all,
		value: EAssetAcquiredStatuses.all, info: null,
	},
	{
		label: EAssetAcquiredStatusesLabels.current,
		value: EAssetAcquiredStatuses.current, info: 'The current date is within the requested time period',
	},
	{
		label: EAssetAcquiredStatusesLabels.past,
		value: EAssetAcquiredStatuses.past, info: 'The requested time period is already in the past',
	},
	{
		label: EAssetAcquiredStatusesLabels.future,
		value: EAssetAcquiredStatuses.future, info: 'The requested time period is in the future',
	},
];
